import { useState, useEffect, useCallback } from 'react';

const ANIMALS = [
  '/images/cat1.gif',
  '/images/cat2.gif',
  '/images/tiger1.gif',
  '/images/tiger2.gif',
  '/images/tiger3.gif',
];

export default function WalkingAnimal() {
  const [animals, setAnimals] = useState([]);

  const spawn = useCallback(() => {
    const src = ANIMALS[Math.floor(Math.random() * ANIMALS.length)];
    const duration = 10 + Math.random() * 10;
    const size = 48 + Math.floor(Math.random() * 32);
    const fromRight = Math.random() > 0.5;
    const id = Date.now() + Math.random();

    const newAnimal = { id, src, duration, size, fromRight };

    setAnimals((prev) => [...prev, newAnimal]);

    // 화면 밖으로 나가면 제거
    setTimeout(() => {
      setAnimals((prev) => prev.filter((a) => a.id !== id));
    }, duration * 1000);
  }, []);

  useEffect(() => {
    // 초기 랜덤 딜레이 후 첫 등장
    const initialDelay = setTimeout(spawn, Math.random() * 5000);

    // 이후 8~20초 간격으로 반복 스폰
    let timer;
    const scheduleNext = () => {
      timer = setTimeout(() => {
        spawn();
        scheduleNext();
      }, 8000 + Math.random() * 12000);
    };
    scheduleNext();

    return () => {
      clearTimeout(initialDelay);
      clearTimeout(timer);
    };
  }, [spawn]);

  return (
    <div className="fixed left-0 right-0 pointer-events-none z-[55] overflow-hidden h-24" style={{ bottom: 'calc(4rem + env(safe-area-inset-bottom))' }}>
      {animals.map((a) => (
        <img
          key={a.id}
          src={a.src}
          alt=""
          className="absolute bottom-0 select-none pointer-events-none"
          style={{
            height: a.size,
            transform: a.fromRight ? 'scaleX(-1)' : 'none',
            animation: `${a.fromRight ? 'walk-rtl' : 'walk-ltr'} ${a.duration}s linear forwards`,
          }}
        />
      ))}
      <style>{`
        @keyframes walk-ltr {
          from { left: -120px; }
          to { left: calc(100vw + 120px); }
        }
        @keyframes walk-rtl {
          from { right: -120px; }
          to { right: calc(100vw + 120px); }
        }
      `}</style>
    </div>
  );
}
